export class DeviceImageConstants {
  public static DEFAULT_IMAGE  = '/assets/images/img_empty_icon.png';
  public static SWITCHING_DEVICE_BRIDGE_WIDTH = 52;
  public static RESI9KV_HEIGHT_OFFSET = -7;
}
